import { useContext } from 'react';

import { StateContext } from 'state/state-context';
import { TextHeader } from 'components/Typography/TextHeader';
import { roundedContainer } from 'components/Container/styles.module.scss';
import { needHelp, roundedLink } from './styles.module.scss';

const InfoSidebar = () => {
  const { content, brand } = useContext(StateContext);
  const contactNo = content(`sidebarTel1.${brand}`);
  const abroadContactNo = content(`sidebarTel2.${brand}`);
  const openingTimes = content(`openingTimes.${brand}`);

  return (
    <aside data-test="infoside" className={roundedContainer}>
      <TextHeader type="h2" className={needHelp}>
        {content('sidebarHeader')}
      </TextHeader>
      <p>
        {content('sidebarLine1')}
        <br />
        <a className={`${roundedLink}`} href={`tel:${contactNo}`}>
          {contactNo}
        </a>
        <br />
        {content('sidebarLine2')}
        <br />
        <a className={`${roundedLink}`} href={`tel:${abroadContactNo}`}>
          {abroadContactNo}
        </a>
        <br />
        {openingTimes}
      </p>
    </aside>
  );
};

export { InfoSidebar };
